import gql from 'graphql-tag';

export default gql`
  fragment OfferItemFragment on OfferItem {
    id
    order_id
    original_link
    title
    notes
    store_price_usd
    original_store_price_usd
    shipping_us
    shipping_intl
    customs
    clearance_charges
    fees
    exchange_rate
    subtotal
    tax
    unit_price
    original_unit_price
    quantity
    total_price
    actual_weight
    promotion_description
    expires_at
    currency_code
    missing_information_notes
    state_machine_name
    review_sla
    cashback_percentage
    customs_category {
      id
      name
      name_ar
      customs
      clearance_charges
    }
    photo {
      source_url
      url_thumb
      url_small
      url_xsmall
      source_url
    }
    selected_variations {
      name
      value
    }
    in_usd {
      store_price_usd
      total_price
      unit_price
      clearance_charges
      fees
      customs
    }
    in_currency {
      store_price_usd
      total_price
      unit_price
      clearance_charges
    }
    promotion_type {
      name
      color
    }
    instances {
      id
      state {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./app/containers/Lite/gql/f/item.js